import React, { useEffect, useContext } from "react";
import ResumeIconPlusSVG from "assets/svg/resume-icon-pus";
import { useHistory } from "react-router-dom";
import ResumeItem from "./item";
import { useResume } from "redux/modules/resume/hooks";
import moment from "moment";
import { Context } from "context/context";
import _ from "lodash";
import PopInfo from "components/info-popup/pop-info";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import Spinner from "assets/json/spinner.json";
import { useModal } from "react-modal-hook";
import toast from "react-hot-toast";


export const renderStartDate = (data) => {
  const { start_day=null, start_month=null, start_year=null } =  data || {};
  if (start_day && start_month && start_year) {
    return (
      <span>
        {moment(`${start_year} ${start_month} ${start_day}`).format(
          "DD MMM YYYY"
        )}
      </span>
    );
  } else if (start_month && start_year) {
    return (
      <span>
        {moment(start_month).format("MMM")} {start_year}
      </span>
    );
  } else if (start_year) {
    return <span>{start_year}</span>;
  }

  return null;
};

export const renderEndDate = (data) => {
  const { end_day=null, end_month=null, end_year=null } =  data || {};
  if (end_day && end_month && end_year) {
    return (
      <>
        <span> - </span>
        <span>
          {moment(`${end_year} ${end_month} ${end_day}`).format("DD MMM YYYY")}
        </span>
      </>
    );
  } else if (end_month && end_year) {
    return (
      <>
        <span> - </span>
        <span>
          {moment(end_month).format("MMM")} {end_year}
        </span>
      </>
    );
  } else if (end_year) {
    return (
      <>
        <span> - </span>
        <span>{end_year}</span>
      </>
    );
  }

  return null;
};

export default function ResumeList(props) {
  const { http } = global.services;
  const history = useHistory();
  const { profileId } = props;
  const { resumes, initialize, setResumes,
        loadMore:loadMoreResume,limit,total, isRequesting,finishGetResume,getResume,updateResume,deleteResume } = useResume();
  const {t} = useTranslation();
  const {
    state,
    setState,
    resetState,
    setMilestones,
    resetMilestones,
    setPreviewImage,
  } = useContext(Context);
  const [showLoading, hideLoading] = useModal(() => <LoadingModal />);

  /******** functions ********/
  const fetchResume = async () => {
    let loadMore = false;
    try {
      if(isRequesting || !loadMoreResume) return;
      await getResume();
      const { data } = await http.get("public/resumes", {
        user_profile_id: profileId,
        skip: total,
        limit:limit
      });
      loadMore = data.total > 0 ? true : false;
      const _total = parseInt(total) + data.total;

      setResumes({resumes:data.resumes, total:_total, loadMore:loadMore});
    } catch (err) {
      console.log(err);
    }finally{
      await finishGetResume({loadMore:loadMore})
    }
  };

  /**
   * share/download resume
   *
   * @param id - link id
   */
  const create = async () => {
    if (state.hasOwnProperty("id")) {
      resetState();
      resetMilestones();
    }

    setTimeout(() => {
      history.push(`/resume/builder`);
    });
  };

  /**
   * share/download resume
   *
   * @param id - link id
   */
  const download = async (id) => {
    window.open(`${process.env.REACT_APP_PUBLIC_DOMAIN}/preview/resume/${id}`, "_blank");
  };

  /**
   * preview / edit resume
   *
   * @param item - resume
   */
  const onNavigate = async(item, route) => {
    try{
      let response = null;
      if(!item?.fetched_individual){
          showLoading()
          const { data } = await http.get(`public/resumes/${item.id}`);
          response = data;
          updateResume(data);
      }
      let position = response?.milestone_position || item?.milestone_position || [];
      let resume_milestones = response?.resume_milestones || item.resume_milestones || [];
      let data = {
        personal: response?.personal_info || item.personal_info,
        more: response?.more_info || item.more_info,
        show_milestone_image: response?.show_milestone_image || item.show_milestone_image,
        show_private_milestone: response?.show_private_milestone ?? item?.show_private_milestone ?? false,
        show_qr_milestone:response?.show_qr_milestone || item.show_qr_milestone,
        show_qr_reels: response?.show_qr_reels || item.show_qr_reels,
        hideOccupation:item?.hideOccupation || [],
        milestone_position:position,
        template_url:response?.template_url || item?.template_url || null
      };

      if (item.social_media || response?.social_media) {
        data.social = response?.social_media || item.social_media;
      }
      console.trace(data.social)

      if (item.personal_info.hasOwnProperty("profile_image")) {
        setPreviewImage(
          item.personal_info.profile_image || item?.profile_image_withURL 
        );
      } else {
        setPreviewImage("");
      }

      setState((prev) => ({
        ...prev,
        ...data,
        // Every other field on this object prefers the freshly fetched resume;
        // this one did not, so a list row without template_name opened the
        // builder with nothing selected.
        templateName: response?.template_name || item.template_name,
        color: item.template_color,
        link_id: item.link_id,
        id: item.id,
      }));

      if (!_.isEmpty(resume_milestones)) {
        Object.keys(resume_milestones).forEach((key) => {
          const milestones = resume_milestones[key]?.map?.((m) => m.milestone);
          setMilestones((prev) => ({
            ...prev,
            [key]: milestones,
          }));
        });
      } else {
        resetMilestones();
      }

      if (route === "preview") {
        history.push("/resume/preview");
      } else if (route === "edit") {
        history.push("/resume/builder", {
          isEdit: true,
          resumeDetails: item,
        });
      }
    }catch(e){
      console.trace(e)
    }finally{
      hideLoading()
    }
    
  };
  const onRemove = async(item) =>{
    try{
        showLoading()
        const { data } = await http.delete(`public/resumes/${item.id}`);
        deleteResume({id:item.id});
        toast.success('Successfully deleted.');
    }catch(e){
      console.log(e)
    }
    finally{
      hideLoading()
    }
  }

  /******** use effects ********/
  // useEffect(() => {
  //   if (initialize) {
  //     fetchResume();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [initialize]);

  return (
    <div className="w-full bg-white rounded-md px-5 py-10 md:pb-14 md:pt-8">
      <div className="w-full grid gap-y-8">
        <div className="w-full flex flex-row gap-x-2 items-center">
          <h1 className="text-2xl font-semibold text-lightBlack">{t('myResumes')}</h1>
          <PopInfo containerClass="relative" type="resume" />
        </div>

        {/* resume lists */}
        <div className="w-full">
          <div className="w-full grid 4sm:grid-cols-2 1smd:grid-cols-3 xl:grid-cols-4 gap-7.5">
            <div
              className="w-full h-400 4sm:h-full bg-modalGray resume-create flex flex-col items-center justify-center space-y-4.5 cursor-pointer"
              style={{ minHeight: 400 }}
              onClick={() => create()}>
              <ResumeIconPlusSVG />
              <p className="text-darkerGray font-semibold">{t('createNewResume')}</p>
            </div>
            {/* list resume */}
              {resumes.map((obj, index) => (
                <ResumeItem
                  {...obj}
                  key={`resume-${index}`}
                  onDownload={() => download(obj.link_id)}
                  onEdit={() => onNavigate(obj, "edit")}
                  onPreview={() => onNavigate(obj, "preview")}
                  image_template = {obj.template_url}
                  onRemove={() => onRemove(obj)}

                />
              ))}  
            {/* end here */}
          </div>
            {
                (isRequesting) ? 
                    <div className="flex flex-col justify-center items-center my-20">
                      <Lottie animationData={Spinner} className="w-16 h-16" />
                      <p className="text-md font-semibold text-gray-500">Loading</p>
                    </div>:
                    <div className="text-center"> 
                    </div>
              }
        </div>
        {/* end: lists */}
        
      </div>
    </div>
  );
}

export const groupArraysWithType = (arraysWithType, minLimit = 9,maxLimit = 9) => { //minLimit is for first page and maxLimit for the second page depend on template
  const result = [];
  let group = [];
  let limit = minLimit;

  arraysWithType.forEach(({ array, type }) => {
    array.forEach((item, index) => {
      if (group.length < limit) {
        group.push({ ...item, type });
      }
      if (group.length === limit) {
        result.push(group);
        group = [];
        limit = maxLimit;
      }
    });
  });

  if (group.length > 0) {
    result.push(group);
  }

  return result;
};


/**
 * Drop private milestones from a resume's {featured,current,past} display set
 * unless the "Show Private Milestones" toggle is on. This is a DISPLAY filter
 * only — it must never touch the saved selection, just what is rendered on the
 * resume preview / full preview / PDF. Safely degrades to a no-op if the data
 * doesn't carry an is_private / privacy flag. (Marker.io MCF-1827)
 */
export const filterPrivateMilestones = (milestones = {}, showPrivate = false) => {
  if (showPrivate) return milestones;
  const strip = (arr) =>
    Array.isArray(arr)
      ? arr.filter((m) => !(m?.is_private || m?.privacy === "Private"))
      : arr;
  return {
    ...milestones,
    featured: strip(milestones?.featured),
    current: strip(milestones?.current),
    past: strip(milestones?.past),
  };
};


export const mergeArray = (arraysWithType) => { //minLimit is for first page and maxLimit for the second page depend on template
  const result = []; 

  arraysWithType.forEach(({ array, type }) => {
    array.forEach((item, index) => { 
      result.push({ ...item, type }); 
    });
  }); 
  return result;
};

export const A4_SIZE = {
  // width: "210mm", // 794 px
  // height: "297mm", // 1123px
  width: "816px", 
  // height: "842px",
  height: "305mm",
  overflow: "hidden",
  // marginRight: "20px",
  heightTOpx:1123
  };

  export const A4_SIZE_BUILD = {
    width: "695px", 
    height: "849px",
    heightTOpx:1123,
    maxHeight:"849px",
    overflow: "hidden"
    };

export const LONG_SIZE = {
  width: "816px", // 8.5 inch
  maxWidth: "816px", // 8.5 
  // minHeight: "1248px", // 13 inch (1056px is 11 inch)
  minHeight: "1123px", // 13 inch (1056px is 11 inch)
};


function LoadingModal() {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
      <div className="bg-transparent px-6 py-4 text-center">
        <div className="flex flex-col justify-center items-center my-20 text-white">
            <Lottie animationData={Spinner} className="w-16 h-16 text-white" />
            <p className="text-md font-semibold text-gray-500">Loading...</p>
          </div> 
      </div>
    </div>
  );
}